<template>
  <div>
    <div class="learnedNew" v-for="(item,key) in learningList" :key="key">
      <div class="learned-head">
        <div class="learned-img"><img :src="item.img" alt=""></div>
        <div class="head-right">
          <h2>{{ item.name }}</h2>
          <div>课时数： <span class="redColor">{{ item.mxCount }}课时</span></div>
          <div>所属工种：{{ item.catgoryName }}</div>
          <div>价格： <span class="redColor font-size18">免费</span></div>
          <div><span class="redColor">提醒：</span>观看本课程后，不可观看其他课程，需观看完本课程的全部课时，答题完成后，方可继续选择其他课程观看</div>
<!--          <div><el-button type="primary" round>开始学习</el-button></div>-->
        </div>
      </div>
      <div class="learned-content">
        <el-tree
          :data="item.stageList"
          node-key="id"
          :default-expanded-keys="expandedKeys"
          :expand-on-click-node="false"
          :props="defaultProps"
          @node-expand="handleNodeClick"
          @node-collapse="collapseNodeClick"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span @click="() => playClick(data)">{{ data.name }}</span>
            <span>
              <el-button
                type="text"
                size="mini"
                v-if="data.vedio"
                :class="data.studyFinish != 0 ? 'greenColor' : 'redColor'"
                @click="() => playClick(data)">
                {{ data.studyFinish != 0 ? '已观看' : '未观看'}}
              </el-button>
              <el-button
                type="text"
                size="mini"
                style="width: 38px;color: #808080"
                v-if="data.studyFinish == 0 || (data.studyFinish != 0 && data.stFinish == 3)">
                {{data.stFinish == 3 ? '' : '未答题'}}
              </el-button>
              <el-button
                type="text"
                size="mini"
                v-else
                :class="data.stFinish == 1 ? '' : 'redColor'"
                @click="() => answerBtnClick(data, item.id)">
                {{ data.stFinish == 1 ? '已答题' : '未答题'}}
              </el-button>
            </span>
          </span>
        </el-tree>
      </div>
    </div>

    <play-view v-if="playVisible" :src="src" :title="title" :mxId="mxId"></play-view>
    <answer-view v-if="answerVisible && !playVisible" :checkCode="checkCode" :type="answerType" :answerId="answerId" :olCurriculumId="olCurriculumId"></answer-view>
    <el-dialog
      width="360px"
      title="验证信息"
      :close-on-click-modal="false"
      :visible.sync="innerVisible"
      :before-close="handleCloseInner"
      append-to-body>
      <div class="testBox">答题前，请前往移动端进行人脸识别验证</div>
      <div class="img-box">
        <div id="qrCode" ref="qrCodeDiv"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex'
import playView from './playView'
import answerView from './answerView'
import QRCode from "qrcodejs2";

export default {
  name: 'learnedNew',
  props: ['learningList', 'showPlay'],
  computed: {
    ...mapState(['playVisible', 'answerVisible'])
  },
  components: {
    playView,
    answerView
  },
  data () {
    return {
      defaultProps: {
        children: 'userMxList',
        label: 'name'
      },
      src: 'http://www.sxlihang.cn/third.mp4',
      title: '',
      answerId: '',
      mxId: '',
      olCurriculumStage: '',
      answerType: 3, // 3课时答题 2阶段答题
      expandedKeys: [], // 默认展开树节点
      olCurriculumId: '',   // 课程id
      checkCode: null,    // 人脸验证code
      innerVisible: false,   // 人脸验证弹窗
      getJurisdictionShow: null,  // 验证人脸计时器
      jurisdictionTime: 0,  // 判断权限时间计算，5分钟后依旧没有验证成功则自动跳出
    }
  },
  methods: {
    ...mapMutations(['setPlayVisible', 'setAnswerVisible']),
    handleNodeClick (data) {
      this.expandedKeys.push(data.id)
    },
    collapseNodeClick (data) {
      let index = this.expandedKeys.indexOf(data.id)
      this.expandedKeys.splice(index, 1)
    },
    answerBtnClick (data, id) {
      if (data.stFinish != 1) {
        this.innerVisible = true
        this.testClick(data.id)
      } else {
        this.checkCode = null
        this.answerLearning = true
        this.setAnswerVisible(true)
      }
      this.answerType = data.vedio ? '3' : '2'
      this.answerId = data.id
      this.olCurriculumId = id
    },
    playClick (data) {
      if (data.vedio) {
        this.title = data.name
        this.src = data.vedio
        this.mxId = data.id
        this.setPlayVisible(true)
      }
    },
    // 获取验证二维码
    testClick (id) {
      // 创建验证 获取checkCode
      this.$http({
        method: 'post',
        url: '/api/renren-fast/app/stfacecheckrecord/createFaceCheck',
        data: {
          mxId: id
        }
      }).then((result) =>{
        if (result.data.code == 0) {
          this.checkCode = result.data.data.checkCode
          this.$nextTick(() => {
            document.getElementById('qrCode').innerHTML = ''
            // let text = "http://101.201.153.146:8062?token=" + sessionStorage.getItem('token') + "&id=" + 7
            let text = '{"token":"' + sessionStorage.getItem('token') + '","userID":"' + JSON.parse(sessionStorage.getItem('user')).userId + '","checkCode":"' + this.checkCode + '","from":"2"}'
            /* eslint-disable no-new */
            new QRCode('qrCode', {
              text: text,
              width: 150,
              height: 150,
              // 二维码颜色
              colorDark: '#0a0a0a',
              // 二维码背景色
              colorLight: '#ffffff',
              // 容错率，L/M/H
              correctLevel: QRCode.CorrectLevel.M
            })

            this.getJurisdictionShow = setInterval(this.getJurisdiction, 5000)
          })
        }
      })
    },
    //  调起人脸验证二维码后判断是否拥有权限
    getJurisdiction () {
      let that = this
      if (that.jurisdictionTime > 60000) {
        that.jurisdictionTime = 0
        that.handleCloseInner()
        that.$message({
          message: '验证超时，请重新验证',
          type: 'warning'
        })
      }
      this.jurisdictionTime += 5000
      this.$http({
        method: 'post',
        url: '/api/renren-fast/app/stfacecheckrecord/queryCheckResult/' + this.checkCode
      }).then((result) => {
        if (result.data.data.checkFlag == 1) {
          this.setAnswerVisible(true)
          this.handleCloseInner()
        }
      })
    },
    handleCloseInner() {
      this.innerVisible = false
      clearInterval(this.getJurisdictionShow)
    }
  }
}
</script>

<style lang="scss" scoped>
.learnedNew{
  width: 100%;
  border-radius: 10px;
  border: 1px solid #999999;
  margin-bottom: 15px;
  .learned-head{
    padding: 20px;
    border-bottom: 1px solid #999999;
    display: flex;
    .learned-img{
      width: 400px;
      height: 190px;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .head-right{
      margin-left: 20px;
      div{
        margin-top: 15px;
      }
    }
  }
  .learned-content{
    padding: 10px;
  }
  .redColor{
    color: #f13e3e;
  }
  .font-size18{
    font-size: 18px;
    font-weight: bold;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .greenColor{
    color: #5daf34;
  }
}
.testBox{
  width: 100%;
  text-align: center;
}
.img-box{
  width: 100%;
  height: 100%;
  #qrCode{
    width: 150px;
    height: 150px;
    margin: 20px auto;
  }
}
</style>
<style>
.learnedNew .el-button+.el-button{
  margin-left: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/learnedNew.vue